import { TrackingRow } from 'pages/certificates/components'
import {
  getCmHeroPrices,
  HeroVariant,
  type HeroVariantProps,
} from 'pages/certificates/experiments/mccerts-2548_v1-subscriptions-entry-point'
import { PassOnlyHeroModule } from '../PassOnlyHeroModule'
import { PassPriceLockup } from '../PassPriceLockup'

export const HeroVariantPassOnly = (props: HeroVariantProps) => {
  const { subscriptionPrice } = getCmHeroPrices(
    props.product,
    props.subscriptionOffer,
  )

  return (
    <TrackingRow
      row_name='hero-subs-only-annual'
      location='hero-subs-only-annual'
      visibilityConfig={{ threshold: 0.01 }}
    >
      <HeroVariant {...props} releaseLabel={props.program.releaseLabel}>
        <PassOnlyHeroModule
          priceLockup={<PassPriceLockup {...subscriptionPrice} />}
        />
      </HeroVariant>
    </TrackingRow>
  )
}
